<template>
  <v-app class="bck">
    
  </v-app>
</template>

<script>
import config from "./../../config.json";
import carousel from 'vue-owl-carousel';
//import VueEasyLightbox from 'vue-easy-lightbox';
import GoTop from '@inotom/vue-go-top';

export default {
  components: {
    GoTop,
    carousel,
  },
  data() {
    return {
      colors: [
          'indigo',
          'warning',
          'pink darken-2',
          'red lighten-1',
          'deep-purple accent-4',
      ],
      slides: [
          'First',
          'Second',
          'Third',
          'Fourth',
          'Fifth',
      ],
      valid: true,
      isLoading: false,
      text: null,
      loggedInUserID: sessionStorage.loggedInUserID,

      list: [],
      categories: [],
      products: [],
      mainOwl: [
        {
          "id": 1,
          "src": "https://csquad.infosyst.in/api/BannerImage/1",
          "header": "Welcome to",
          "name": "WINGS ACTIVITY",
          "description": "We are the wind beneath your wings"
        },
        {
          "id": 2,
          "src": "https://csquad.infosyst.in/api/BannerImage/2",
          "header": "Learning & Fun",
          "name": "LEARNING & PROGRAM",
          "description": "Planting seeds in the hearts and homes of preschoolers is the best way to strengthening children, families and communities."
        },
        {
          "id": 3,
          "src": "https://csquad.infosyst.in/api/BannerImage/4",
          "header": "Learning & Fun",
          "name": "LEARNING & PROGRAM",
          "description": "Planting seeds in the hearts and homes of preschoolers is the best way to strengthening children, families and communities."
        },
        {
          "id": 4,
          "src": "https://csquad.infosyst.in/api/BannerImage/3",
          "header": "Learning & Fun",
          "name": "LEARNING & PROGRAM",
          "description": "Planting seeds in the hearts and homes of preschoolers is the best way to strengthening children, families and communities."
        },
      ],

      items: [
          {
            src: 'https://sasitechnologies.in/csquad/assets/images/slider/44.jpg',
          },
          {
            src: 'https://sasitechnologies.in/csquad/assets/images/slider/11.jpg',
          },
          {
            src: 'https://sasitechnologies.in/csquad/assets/images/slider/22.jpg',
          },
          {
            src: 'https://sasitechnologies.in/csquad/assets/images/slider/33.jpg',
          }
      ],

      btnSave: false,
      dialog: false,

      form: {
        email: null
      },
      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
        },
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
    };
  },
  
   mounted() {
     this.getData();
     this.getData1();
   },

 methods: {
   getData1() {
      this.axios
        .get(config.API + "Testimonials1", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.list = res.data;
          this.$Progress.finish();
          this.getData1();
        })
        .catch(err => {
          this.$Progress.fail();
        });
    },
   onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `Enquiries`,
            {
              email: this.form.email
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.dialog = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error("Something went wrong!!");
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },
    cancel() {
        this.$refs.form.reset();
        this.dialog = false;
    },
   cart(item) {
     this.$store.commit('addToCart', item);
   },
   getData() {
     this.axios
        .get(config.API + "Home", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.categories = res.data.categories;
          this.products = res.data.products;
          this.getData();
        });
   },

   cat1() {
     console.log('CAT 1');
     sessionStorage.setItem("id", 8);
     this.$router.push(`/detail`);
   },
   cat2() {
     console.log('CAT 2');
     sessionStorage.setItem("id", 7);
     this.$router.push(`/detail`);
   },
   cat3() {
     console.log('CAT 3');
     sessionStorage.setItem("id", 5);
     this.$router.push(`/detail`);
   },
   cat4() {
     console.log('CAT 4');
     sessionStorage.setItem("id", 6);
     this.$router.push(`/detail`);
   },

   detail(item) {
     sessionStorage.setItem("id", item.id);
     this.$router.push(`/detail`);
   },

   uploadBtn(item) {
     sessionStorage.setItem("id", item.id);
     this.$router.push(`/uploadPrescription`);
   },
   catAll() {
     this.$router.push(`/categoryList`);
   },

   wish(item) {
     this.$store.commit('addToWish', item);
   },

   productDetail(item) {
     this.$router.push(`/productDetail/` + item.itemId);
    },

   track() {
     if(this.loggedInUserID != null) {
       this.$router.push(`/myOrder`);
     } else {
       this.$router.push(`/login`);
     }
   }
 },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200&display=swap'); 
</style>

<style scoped>
.txt {
  font-family: 'Montserrat', sans-serif !important;
}
._3DH4g {
    width: 100%;
    min-height: 260px;
    max-height: 280px;
}
.mycarousel {
  width: 100% !important;
  min-width: 100% !important;
}
.icon-bar {
  position: fixed;
  top: 55%;
  z-index: 1;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

/* Style the icon bar links */
.icon-bar a {
  display: block;
  text-align: center;
  padding: 16px;
  transition: all 0.3s ease;
  color: white;
  font-size: 20px;
}
.facebook {
  background: #3B5998;
  color: white;
}

.twitter {
  background: #55ACEE;
  color: white;
}

.google {
  background: #dd4b39;
  color: white;
}

.linkedin {
  background: #007bb5;
  color: white;
}

.youtube {
  background: #bb0000;
  color: white;
}
.banner1 {
  background-image: url('https://csquad.infosyst.in/api/BannerImage/1');
  background-size: contain;

  height:450px;
}
.banner {
  background-size: contain;
  height: 450px !important;
}
.banner2 {
  background-image: url('https://csquad.infosyst.in/api/BannerImage/2');
  background-size: contain;

  height:450px;
}
.banner3 {
  background-image: url('https://csquad.infosyst.in/api/BannerImage/4');
  background-size: contain;

  height:450px;
}
.banner4 {
  background-image: url('https://csquad.infosyst.in/api/BannerImage/3');
  background-size: contain;

  height:450px;
}
.bannertxt {
  font-family: 'Archivo Black', sans-serif;;
}
/* .banner {
  background-image: url('https://www.anstro.co.za/wp-content/uploads/2017/08/Anstro-Catering-Equipment-Slide1-1030x332.jpg');
  background-size: cover;

  height:550px;
} */
.txt_dec:hover {
  text-decoration: none !important;
}
.hvr:hover {
  cursor: pointer;
  border-radius: 5px !important;
  text-decoration: none !important;
}
.wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offsets {
  top: -50px;
  position: relative;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-sheet--offsetf {
  top: -100px;
  position: relative;
}
.swo {
  box-shadow: none !important;
}
.prdt {
  background-size: cover;
}
.prdt1 {
  background-size: cover;
  height: auto;
}
.opa {
  opacity: 1;
}
.tourtheme {
  height: 180px;
  margin: 5px;
  background-size: cover;
}
.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.top-left {
  font-family: 'Roboto Mono', monospace;
  font-size:40px ;
  padding-top: 200px;
  color: white;
  text-align: center;
}
.salont {
  font-family: 'Patua One', cursive;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.recent {
  font-family: 'Nanum Gothic', sans-serif;
}
.srch {
  position: absolute;
  z-index: 10;
  left: 11%;
  top: 0%;
}
.srch1 {
  position: absolute;
  z-index: 10;
  left: 11%;
  top: 0%;
}
.flip-box {
  background-color: transparent;
  width: 300px;
  height: 200px;
  border: 1px solid #f1f1f1;
  perspective: 1000px;
}

.flip-box-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}

.flip-box:hover .flip-box-inner {
  transform: rotateY(180deg);
}

.flip-box-front, .flip-box-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-box-front {
  background-color: #bbb;
  color: black;
}

.flip-box-back {
  transform: rotateY(180deg);
}

@keyframes zoominoutsinglefeatured {
    0% {
        transform: scale(1,1);
    }
    50% {
        transform: scale(1.2,1.2);
    }
    100% {
        transform: scale(1,1);
    }
}

.cardcontainer img {
    animation: zoominoutsinglefeatured 1s infinite ;
}
.track {
  background-image: url('../../assets/track.jpg');
  background-size: cover;
  height: 300px;
  margin: 25px;
}
.subscribe {
  background-image: url('https://assets.weforum.org/project/image/FQuygXPMd2A4O0deuG3gXRCqpEng4BdwvO3kMkn6Aoo.jpeg');
  background-size: cover;
  height: auto;
  margin: 25px;
}
.track1 {
  background-color: #F3F3F3 !important;
  background-size: cover;
  height: 300px;
  margin: 25px;
}
.ordr:hover {
  background-color: #166be0 !important;
}
.fade:hover {
  visibility: visible;
    animation-name: medizinAnimationFadeInUp;
}

.mydiv {
  transition: height 0.5s ease-out 100ms;
}

.mydiv:hover {
  height: 100px;
  cursor: pointer;
}
.bck {
  background-image: linear-gradient(to right, #7bf3f3 , transparent) !important;
}
.myimg {
  transition: height 0.5s ease-out 100ms;
}

.myimg:hover {
  cursor: pointer;
}
.hide {
  display: none;
}

.myDIV:hover + .hide {
  display: inline-block !important;
}
</style>
